module.exports = __webpack_public_path__ + "static/media/githubBlack.b5d6376a.svg";